import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/feedback";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/feedback")(withAlternates(routeOptions, "/feedback"));
